import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Table, Pagination, DatePicker, Button, Modal, Select, Tooltip, Input } from 'components';
import { CleanIcon, AddIcon, EditIcon, DeleteIcon, Menu } from 'assets/icons';
import { Constants, Colors, Globals, checkPermission, Permissions } from 'utils';
import { BankService } from 'services';

interface Props extends RootState {
	history: any;
	payment_method_id: number;
	banks: any;
	document_types: any;
	phonecodes: any;
	payment_methods: any;
}

class UpdatePaymentMethod extends React.Component<Props> {

	state = {
		form: {
			email: '',
			phone: '',
			phonecode_id: '',
			document_type_id: '',
			document: '',
			bank_id: ''
		}
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await BankService.admin.getPaymentMethod({
			payment_method_id: this.props.payment_method_id
		});
		this.setState({
			form: {
				...this.state.form,
				email: res.payment_method.email || '',
				phone: res.payment_method.phone || '',
				phonecode_id: res.payment_method.phonecode_id || '',
				document_type_id: res.payment_method.document_type_id || '',
				document: res.payment_method.document || '',
				bank_id: res.payment_method.bank_id || '',
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		await BankService.admin.updatePaymentMethod({
			...this.state.form,
			payment_method_id: this.props.payment_method_id
		});
		Globals.showSuccess("Se ha modificado método de pago correctamente");
		this.load(true);
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		const payment_method: any = this.props.payment_methods.find((i: any) => i.id == this.props.payment_method_id);

		return (
			<div id="admin-update-payment-method">
				<div className="container-form row">
					<h3>{ payment_method?.name }</h3>
					{
						this.props.payment_method_id == Constants.PAYMENT_METHODS.MOVIL && (
							<React.Fragment>
								<div className="col-12">
									<Select
										disabled={ !checkPermission(Constants.MODULES.BANK_ACCOUNTS,'write',this.props.user) }
										label="Banco"
										name="bank_id"
										onChange={ this.change }
										value={ this.state.form.bank_id }
										options={ this.props.banks.map((i: any) => {
											return {
												value: i.id,
												label: i.name
											}
										}) } />
								</div>
								<div className="col-md-6">
									<div className="container-select">
										<p className="label">Tipo de Documento</p>
										<div>
											<Select
												disabled={ !checkPermission(Constants.MODULES.BANK_ACCOUNTS,'write',this.props.user) }
												className="document_type"
												name="document_type_id"
												onChange={ this.change }
												value={ this.state.form.document_type_id }
												options={ this.props.document_types.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
											<Input
												disabled={ !checkPermission(Constants.MODULES.BANK_ACCOUNTS,'write',this.props.user) }
												type="number"
												color="white"
												value={ this.state.form.document }
												name="document" 
												placeholder="Documento"
												onChange={ this.change } />
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="container-select">
										<p className="label">Teléfono</p>
										<div>
											<Select
												disabled={ !checkPermission(Constants.MODULES.BANK_ACCOUNTS,'write',this.props.user) }
												name="phonecode_id"
												onChange={ this.change }
												value={ this.state.form.phonecode_id }
												options={ this.props.phonecodes.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
											<Input
												disabled={ !checkPermission(Constants.MODULES.BANK_ACCOUNTS,'write',this.props.user) }
												type="number"
												color="white"
												value={ this.state.form.phone }
												name="phone" 
												placeholder="Teléfono"
												onChange={ this.change } />
										</div>
									</div>
								</div>
							</React.Fragment>
						)
					}
					{
						this.props.payment_method_id != Constants.PAYMENT_METHODS.MOVIL && (
							<div className="col-12">
								<Input
									disabled={ !checkPermission(Constants.MODULES.BANK_ACCOUNTS,'write',this.props.user) }
									color="white"
									value={ this.state.form.email }
									name="email" 
									label="Correo electrónico"
									onChange={ this.change } />
							</div>
						)
					}
					{
						checkPermission(Constants.MODULES.BANK_ACCOUNTS,'write',this.props.user) && (
							<div className="col-12 text-center">
								<Button type="button" onClick={ this.submit }>
									Guardar
								</Button>
							</div>
						)
					}
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(UpdatePaymentMethod);